export default __webpack_public_path__ + "static/media/mysql.0f14bf33.svg";